import { useState, useEffect } from "react";
import { Modal, Col } from "antd";
import AccountBalanceItem from "../AccountBalanceItem";
import ListPage from "../Page/listPage";
import CircularProgress from "../CircularProgress";
import { GetCustomerBalance } from "../../API/AccountBalance";
import Classes from "./index.module.css";
const infoModal = Modal.info;
const ErrorModal = Modal.error;
export default function AccountBalanceDetail({ customer }) {
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: "سند",
      dataIndex: "key",
      key: "key",
      width: 50,
      render: (text) => <span className="gx-link">{text}</span>,
      sort: true,
      search: true,
      num: true,
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
      search: true,
      sort: true,
    },
    {
      title: "شرح",
      dataIndex: "description",
      key: "description",
      search: true,
    },
    {
      title: "بدهکار",
      dataIndex: "indebted",
      key: "indebted",
      search: true,
    },
    {
      title: "بستانکار",
      dataIndex: "creditor",
      key: "creditor",
      search: true,
    },
    {
      title: "مانده",
      dataIndex: "remain",
      key: "remain",
      search: true,
    },
    {
      title: "تشخیص",
      dataIndex: "diagnosis",
      key: "diagnosis",
      search: true,
    },
  ];
  const tableTitles = [
    "ردیف",
    "عنوان",
    "عنوان En",
    "واحد",
    "دقت",
    "عنوان کسر",
    "عنوان کسر En",
    "دقت گرد کردن",
    "نماد",
    "خلاصه",
  ];

  function onCall() {
    setLoading(true);
    console.log("customer",customer)
    GetCustomerBalance({ codehesab: customer.code_hesab })
      .then((i) => {
        
        infoModal({
          title: customer.name + " گردش حساب",
          className: Classes.modal,
          content: (
            <>
              
                <ListPage
                  columns={columns}
                  tableTitles={tableTitles}
                  data={i}
                  reloader={onCall}
                  pagsize={5}
                />
              
            </>
          ),
        });
      })
      .finally(() => {
        setLoading(false);
        
      }).catch((e)=>{console.error(new Error("loading Balance Error = ",e))});
  }

  return (
    <Col span={24}>
      <AccountBalanceItem {...customer} loading={loading} btn={onCall} />
    </Col>
  );
}
